<div class="py-5">
    <h6 class="text-base mb-3">{{ 'TENANT.EMPTY_MSG' | translate }}</h6>
    <img class="block mx-auto my-4" src="/assets/img/tenant-empty-img.svg" alt="No Tenant added yet!" />
    <p-button (onClick)="GoToCreateTenant()" icon="fa fa-plus" label="Create new Tenant" styleClass="text-sm p-button-outlined"></p-button>
</div>